//@flow
import { mapProps, compose, lifecycle } from 'recompose'
import { ModalBody, ModalHeader, Button, ModalFooter } from 'reactstrap'
import { connect } from 'react-redux'
import NumberInput from 'react-number-format'

import { optionsSendLinkMethod } from './constants'
import RadioButton from '../../../common-components/radio-button-group'
import { getRemoteSellingState } from 'e-submission/domain/data-model/form/selectors'
import { getCurrentApp } from '../../apps/selectors'
import {
  setEmailRemoteSelling,
  setPhoneNumberRemoteSelling,
  setSendingMethodRemoteSelling,
  closeSendingLinkModalRemoteSelling,
} from '../../apps/actions'
import createTextInput from '../../components/Form/Input/TextInput'
import { Modal } from '../../../common-components'
import type { AppState } from 'quick-quote/reducers'
import { renderErrorMessage } from 'common-components/view-logic'
import { createRemoteSellingCase } from 'core/actions'
import { validateEmail } from 'e-submission/utils'
import { validateSendLinkInputPopup } from 'e-submission/domain/data-model/form/validation'

const hocText = mapProps(({ value, onChange }) => {
  return {
    value,
    onChange,
  }
})

const TextInput = createTextInput(hocText)
const SendLinkButton = (props) => {
  const { onExit, isInvalid, handlerCreateCaseEkyc, disabled } = props
  return (
    <div style={{ textAlign: 'center' }}>
      <Button
        disabled={disabled}
        color={!isInvalid ? 'disabled' : 'primary'}
        className="primary"
        onClick={() => {
          handlerCreateCaseEkyc()
          onExit()
        }}
      >
        ยืนยัน
      </Button>
    </div>
  )
}

function isEnableSubmitButton(sendingMethod, email, sms) {
  if (sendingMethod === 'sms') {
    return sms && sms.length === 10
  }

  return validateEmail(email)
}
export const SendLinkRoomIdNotExist = ({
  isOpen,
  openModal,
  closeModal,
  onExit = () => {},
  setMethod,
  method,
  setPhoneNumber,
  setEmail,
  validateInput,
  createRemoteSellingCases,
  email,
  sms,
}) => {
  const isValid = isEnableSubmitButton(method, email, sms)

  return (
    <Modal isOpen={isOpen} backdrop={true} size="md" modalClassName="default-bootstrap remote-selling-modal">
      <ModalHeader
        toggle={() => {
          closeModal()
        }}
      >
        ส่งลิงก์ให้ผู้ขอประกันเพื่อทำ Remote Selling
      </ModalHeader>
      <ModalBody>
        กรุณาเลือกช่องทางการส่งลิงก์เพื่อทำ Remote Selling
        <div className={`form-group ${!isValid ? 'has-danger' : ''}`}>
          <RadioButton options={optionsSendLinkMethod} value={method} onChange={(e) => setMethod(e)} />
          {method === 'email' ? (
            <TextInput value={email} setValue={setEmail} />
          ) : (
            <NumberInput
              value={sms}
              format={'##########'}
              onChange={(e) => setPhoneNumber(e.target.value)}
              className="form-control"
            />
          )}
          {isValid ? null : renderErrorMessage('validate-method-error-message')(validateInput, 'VALIDATION')}
          <div
            style={{ minWidth: '100%' }}
            className="validation-message attached-icon info-message-wrap form-control-feedback"
          >
            <p>ท่านสามารถเลือกช่องทางในการส่งลิงก์ผ่านทางช่องทางที่ท่านต้องการ</p>
          </div>
        </div>
        <SendLinkButton
          disabled={!isEnableSubmitButton(method, email, sms)}
          onExit={() => onExit()}
          openModal={() => openModal()}
          isInvalid={isValid}
          handlerCreateCaseEkyc={() => {
            createRemoteSellingCases()
          }}
        />
      </ModalBody>
      <ModalFooter style={{ justifyContent: 'center' }}></ModalFooter>
    </Modal>
  )
}

const mapStateToSendLinkRoomIdNotExist = (state: AppState) => {
  const app = getCurrentApp(state)
  const remoteSellingState = getRemoteSellingState(app)
  const sms = remoteSellingState.sms
  const email = remoteSellingState.email
  const method = remoteSellingState.sendingMethod
  const textInput = remoteSellingState.sendingMethod === 'sms' ? sms : email

  const validateInput = validateSendLinkInputPopup({ textInput }, method)

  return {
    email,
    sms,
    insuredOrPayer: null,
    isOpen: remoteSellingState.isLinkModalOpen,
    openModal: () => {},
    onExit: () => {},
    setMethod: () => {},
    method,
    handlerCreateCaseEkyc: () => {},
    validateInput,
  }
}

const mapDispatchToSendLinkRoomIdNotExist = (dispatch: Dispatch<*>) => ({
  setEmail: (email) => dispatch(setEmailRemoteSelling(email)),
  setPhoneNumber: (phoneNumber) => dispatch(setPhoneNumberRemoteSelling(phoneNumber)),
  setMethod: (method) => dispatch(setSendingMethodRemoteSelling(method)),
  closeModal: () => dispatch(closeSendingLinkModalRemoteSelling()),
  createRemoteSellingCases: () => dispatch(createRemoteSellingCase()),
})

export default compose(connect(mapStateToSendLinkRoomIdNotExist, mapDispatchToSendLinkRoomIdNotExist))(
  SendLinkRoomIdNotExist
)
